import { Csv } from '@/client/components/icons/individual/Csv';
import { Docx } from '@/client/components/icons/individual/Docx';
import { ExtensionType } from '@/client/services/api/graphql/gql/graphql';
import { GenericFile } from '@/client/components/icons/individual/GenericFile';
import { Pdf } from '@/client/components/icons/individual/Pdf';

interface FileTypeIconProps {
  /** The type of file to render the icon for */
  type: string;
}

export default function FileTypeIcon({ type }: FileTypeIconProps) {
  switch (type) {
    case ExtensionType.Pdf:
      return <Pdf color="red.500" />;
    case ExtensionType.Docx:
      return <Docx color="#627FFF" />;
    case ExtensionType.Csv:
      return <Csv color="green.400" />;
    default:
      return <GenericFile color="neutral.700" />;
  }
}
